import { IoDownloadOutline, IoOpenOutline } from 'react-icons/io5'
import './Resume.css'

const RESUME_PDF = 'AlanPhamResume2026.pdf'

function Resume() {
  return (
    <div className="resume-page">
      <div className="resume-header">
        <h1 className="resume-title">Résumé</h1>
        <div className="resume-actions">
          <a
            className="resume-action resume-action--primary"
            href={RESUME_PDF}
            download="AlanPhamResume2026.pdf"
          >
            <IoDownloadOutline aria-hidden="true" />
            <span>Download</span>
          </a>
          <a
            className="resume-action"
            href={RESUME_PDF}
            target="_blank"
            rel="noreferrer"
          >
            <IoOpenOutline aria-hidden="true" />
            <span>Open in new tab</span>
          </a>
        </div>
      </div>

      <div className="resume-viewer">
        <iframe src={RESUME_PDF} title="Alan Pham Résumé" />
      </div>
    </div>
  )
}

export default Resume
